export default __webpack_public_path__ + "static/viota-bc2697a43a863829d34a37c5a1e98bb4.png";